// messageData.js
export const softwareEngineeringMessages = [
    { text: "Hi there.", sender: "interviewer", timestamp: "11:54:58" },
    { text: "Let's get started", sender: "interviewer", timestamp: "11:55:01" },
    { text: "What are the principles of object-oriented programming?", sender: "interviewer", timestamp: "12:55:10" },
    {
        text: "<h2>Principles of Object-Oriented Programming (OOP)</h2>\n" +
            "<p><strong>1. Encapsulation:</strong> Encapsulation bundles data and methods within a class, restricting direct access to some components. This protects data integrity and prevents misuse.</p>\n" +
            "<pre><code>class Car {\n  constructor(color) {\n    this._color = color; // Private attribute\n  }\n  getColor() {\n    return this._color; // Public method\n  }\n}\nconst myCar = new Car('red');\nconsole.log(myCar.getColor()); // Output: red</code></pre>\n" +
            "\n" +
            "<p><strong>2. Abstraction:</strong> Abstraction hides complex details, showing only essential features of an object, simplifying interaction with the system.</p>\n" +
            "<pre><code>class Animal {\n  makeSound() { console.log('Some sound'); }\n}\nconst animal = new Animal();\nanimal.makeSound(); // Output: Some sound</code></pre>\n" +
            "\n" +
            "<p><strong>3. Inheritance:</strong> Inheritance allows a class to inherit properties and methods from another class, promoting code reuse.</p>\n" +
            "<pre><code>class Vehicle {\n  start() { console.log('Engine started'); }\n}\nclass Car extends Vehicle {}\nconst myCar = new Car();\nmyCar.start(); // Output: Engine started</code></pre>\n" +
            "\n" +
            "<p><strong>4. Polymorphism:</strong> Polymorphism enables a single interface to represent different underlying forms, allowing objects to respond differently to the same method call.</p>\n" +
            "<pre><code>class Animal {\n  makeSound() { console.log('Animal sound'); }\n}\nclass Dog extends Animal {\n  makeSound() { console.log('Bark'); }\n}\nconst myDog = new Dog();\nmyDog.makeSound(); // Output: Bark</code></pre>\n",
        sender: "copilot",
        timestamp: "12:55:13"
    }
];

export const productManagementMessages = [
    { text: "Hi there,", sender: "interviewer", timestamp: "11:54:58" },
    { text: "Should Lyft enter Indian Market or not?", sender: "interviewer", timestamp: "11:55:01" },
    { text: "<h2>Should Lyft Enter the Indian Market?</h2>\n" +
            "\n" +
            "<h3>Opportunities:</h3>\n" +
            "<ul>\n" +
            "  <li><strong>Large Market Potential:</strong> Growing urban population and demand for ride-hailing services.</li>\n" +
            "  <li><strong>Untapped Cities:</strong> Potential in smaller cities with less competition.</li>\n" +
            "  <li><strong>Innovation:</strong> Opportunity to differentiate with electric vehicles or unique services.</li>\n" +
            "</ul>\n" +
            "\n" +
            "<h3>Challenges:</h3>\n" +
            "<ul>\n" +
            "  <li><strong>Strong Competition:</strong> Dominance of Uber and Ola, requiring significant investment to compete.</li>\n" +
            "  <li><strong>Regulatory Hurdles:</strong> Complex, varying regulations across states.</li>\n" +
            "  <li><strong>Price Sensitivity:</strong> Highly competitive pricing could impact profitability.</li>\n" +
            "  <li><strong>Operational Issues:</strong> Infrastructure and driver management challenges.</li>\n" +
            "</ul>\n" +
            "\n" +
            "<h3>Strategic Considerations:</h3>\n" +
            "<ul>\n" +
            "  <li><strong>Partnerships:</strong> Collaborate with local firms to navigate regulatory and market challenges.</li>\n" +
            "  <li><strong>Niche Focus:</strong> Target premium segments or underserved regions to differentiate.</li>\n" +
            "  <li><strong>Tech Differentiation:</strong> Use superior technology to offer a better user experience.</li>\n" +
            "</ul>\n" +
            "\n" +
            "<h3>Conclusion:</h3>\n" +
            "<li>Entering India could be lucrative but requires a clear strategy to overcome significant challenges.</li>\n" +
            "\n"
            , sender: "copilot", timestamp: "11:55:10" },
];

export const dsMessages = [
    { text: "Hi there,", sender: "interviewer", timestamp: "11:54:58" },
    { text: "Explain the Random Forest Model. How Do You Build a Random Forest Model?", sender: "interviewer", timestamp: "11:55:01" },
    { text: "<h2>Random Forest Model</h2>\n" +
            "    <p>\n" +
            "        A Random Forest is an ensemble learning method that combines multiple decision trees to improve accuracy and prevent overfitting. \n" +
            "        It works by creating multiple decision trees during training using different subsets of data and features.\n" +
            "    </p>\n" +
            "    \n" +
            "    <h2>Steps to Build a Random Forest Model:</h2>\n" +
            "    <ol>\n" +
            "        <li>\n" +
            "            <strong>Data Preparation:</strong> Split the data into training and test sets.\n" +
            "        </li>\n" +
            "        <li>\n" +
            "            <strong>Bootstrap Sampling:</strong> Generate multiple bootstrap samples from the training set.\n" +
            "        </li>\n" +
            "        <li>\n" +
            "            <strong>Train Decision Trees:</strong> For each sample, train a decision tree using a random subset of features at each split.\n" +
            "        </li>\n" +
            "        <li>\n" +
            "            <strong>Aggregate Predictions:</strong> For classification, use majority voting; for regression, average the predictions.\n" +
            "        </li>\n" +
            "        <li>\n" +
            "            <strong>Evaluate:</strong> Assess the model's performance on the test set using appropriate metrics.\n" +
            "        </li>\n" +
            "    </ol>\n" +
            "    <p>\n" +
            "        This approach reduces variance and improves model robustness.\n" +
            "    </p>", sender: "copilot", timestamp: "11:55:10" },
    // Add more messages specific to consulting...
];

export const financeMessages = [
    { text: "Hi there,", sender: "interviewer", timestamp: "14:56:58" },
    { text: "For this section, let’s start with something simple from the realm of basic combinatorics.\n" +
            "\n" +
            "Let’s say you’re playing a dice game. You have 2 dice.\n" +
            "\n" +
            "What’s the probability of rolling at least one 3?\n", sender: "interviewer", timestamp: "14:57:10" },
      { text: "<body>\n" +
            "    <h2>Probability of Rolling At Least One 3</h2>\n" +
            "    <p>To solve the problem of finding the probability of rolling at least one 3 with two dice, we can use basic principles of combinatorics and probability.</p>\n" +
            "    \n" +
            "    <h2>Step-by-Step Solution:</h2>\n" +
            "    <ol>\n" +
            "        <li><strong>Total Possible Outcomes:</strong>\n" +
            "            <p>When rolling two six-sided dice, there are a total of 6 × 6 = 36 possible outcomes.</p>\n" +
            "        </li>\n" +
            "        <li><strong>Calculate Outcomes with At Least One 3:</strong>\n" +
            "            <p>We can approach this by first calculating the number of outcomes that do not have any 3s at all, and then subtracting this from the total number of outcomes.</p>\n" +
            "            <ul>\n" +
            "                <li>The number of outcomes where the first die is <em>not</em> a 3 is 5 (any number but 3).</li>\n" +
            "                <li>Similarly, the number of outcomes where the second die is <em>not</em> a 3 is also 5.</li>\n" +
            "                <li>Therefore, the number of outcomes where <em>neither</em> die is a 3 is 5 × 5 = 25.</li>\n" +
            "            </ul>\n" +
            "        </li>\n" +
            "        <li><strong>Calculate Outcomes with At Least One 3:</strong>\n" +
            "            <p>The number of outcomes with at least one 3 is the total outcomes minus the outcomes with no 3s: 36 - 25 = 11.</p>\n" +
            "        </li>\n" +
            "        <li><strong>Probability Calculation:</strong>\n" +
            "            <p>The probability of rolling at least one 3 is the number of favorable outcomes divided by the total number of possible outcomes.</p>\n" +
            "            <p>Thus, the probability <em>P</em> is:</p>\n" +
            "            <p style=\"font-size: 1.5em;\"><em>P</em> = <sup>11</sup>&frasl;<sub>36</sub></p>\n" +
            "        </li>\n" +
            "    </ol>\n" +
            "    \n" +
            "    <p>So, the probability of rolling at least one 3 when rolling two dice is <strong>11/36</strong>.</p>\n" +
            "</body>", sender: "copilot", timestamp: "11:57:18" },
];
